import uniqBy from "lodash-es/uniqBy";
import { FC } from "react";
import { ApiErrorInterface } from "../../../../../interfaces/ApiErrorResponseInterface";
import styles from "./styles.scss";

interface ApiErrorsProps {
  apiErrors: ApiErrorInterface[];
}

export const ApiErrors: FC<ApiErrorsProps> = ({ apiErrors }) => {
  const uniqueApiErrors = uniqBy(
    apiErrors,
    (error: ApiErrorInterface) => error.message,
  );

  return (
    <>
      {uniqueApiErrors.map((err: ApiErrorInterface, idx: number) => (
        <p key={`sectionStay-${idx}`} className={styles.input_errors}>
          {err.message}
        </p>
      ))}
    </>
  );
};
